import { styled } from "styled-components";
import "./DominoButton.css";

interface DominoButtonProps {
  isFree?: boolean;
  isOnFreePlace?: boolean;
}

export const DominoButton = styled.button.attrs<DominoButtonProps>((props) => ({
  className: `domino ${
    props.isFree
      ? "place-domino"
      : `some-domino ${props.isOnFreePlace ? "" : " some-domino-without-hover"}`
  }`,
}))``;
